import * as React from 'react';
import * as $ from 'jquery';
import terminology from 'javascripts/terminology';
import Pivot from './components/Pivot';
import List from './components/List';
import Timeline from './components/Timeline';
import Gantt from './components/Gantt';
import NowNextLater from './components/NowNextLater';
import Progress from './components/Progress';
import { clamp } from 'lodash';
import classnames from 'classnames';
import NivoChart from './components/NivoChart';
import { Text } from '@aha-app/react-in-place';
import GoogleChart from './components/GoogleChart';
import ExtensionPanel from './components/ExtensionPanel';
import ProjectTimeline from './components/ProjectTimeline';
import Roadmap from './components/Roadmap';
import GenericBookmarkContent from './components/GenericBookmarkContent';
import RichTextPanel from './components/RichTextPanel';
import DevelopChart from './components/DevelopChart';
import {
  DASHBOARD_PANEL_CONTEXT_DASHBOARD,
  DASHBOARD_PANEL_CONTEXT_NOTE,
  DASHBOARD_PANEL_CONTEXT_WHITEBOARD,
} from './constants';
import PriorityList from './components/PriorityList';

export const CONTEXT_IDEA_PORTAL_SECTION = 'idea portal section';
export const CONTEXT_DEFAULT_VIEW_SETTINGS = 'default_views_settings';
export const CONTEXT_PDLC_KEY_VIEW = 'pdlc_key_view';
export const COLUMN_COUNT = 12;
export const ROW_HEIGHT = 70;
export const PANEL_GAP = 20;
export const PANEL_VERSION = 2;

export function bookmarkURL(panel) {
  // If you make a change to this function, make sure to make the same change over at
  // https://github.com/aha-app/aha-faye-app/blob/master/src/workers/serializerWorker.js
  // and app/models/bookmarks/dashboard_panel.rb#panel_bookmark_url

  switch (panel.type) {
    case 'Bookmarks::CustomPivotChart':
    case 'Bookmarks::CustomPivotList':
    case 'Bookmarks::CustomPivotPivot':
    case 'Bookmarks::CustomPivotTimeline':
    case 'Bookmarks::CustomPivot::Chart':
    case 'Bookmarks::CustomPivot::NivoChart':
    case 'Bookmarks::CustomPivot::List':
    case 'Bookmarks::CustomPivot::Pivot':
    case 'Bookmarks::CustomPivot::Timeline':
      return `/bookmarks/custom_pivots/${panel.bookmarkId}`;
    case 'Bookmarks::FeatureGrid':
      return `/bookmarks/feature_grids/${panel.bookmarkId}`;
    case 'Bookmarks::IdeaGrid':
      return `/bookmarks/idea_grids/${panel.bookmarkId}`;
    case 'Bookmarks::IdeaStatusChart':
      return `/bookmarks/idea_status_charts/${panel.bookmarkId}`;
    case 'Bookmarks::IdeaPortalsWatchers':
      return `/bookmarks/idea_portals_watchers/${panel.bookmarkId}`;
    case 'Bookmarks::IdeaTopContributors':
      return `/bookmarks/idea_top_contributors/${panel.bookmarkId}`;
    case 'Bookmarks::ProjectTimeline':
      return `/bookmarks/project_timelines/${panel.bookmarkId}`;
    case 'Bookmarks::EpicTimeline':
      return `/bookmarks/epic_timelines/${panel.bookmarkId}`;
    case 'Bookmarks::Roadmap':
      return `/bookmarks/roadmaps/${panel.bookmarkId}`;
    case 'Bookmarks::GanttRoadmap':
      return `/bookmarks/gantt_roadmaps/${panel.bookmarkId}`;
    case 'Bookmarks::EpicGanttRoadmap':
      return `/bookmarks/epic_gantt_roadmaps/${panel.bookmarkId}`;
    case 'Bookmarks::EpicByReleaseGanttRoadmap':
      return `/bookmarks/epic_by_release_gantt_roadmaps/${panel.bookmarkId}`;
    case 'Bookmarks::InitiativeGanttRoadmap':
      return `/bookmarks/initiative_gantt_roadmaps/${panel.bookmarkId}`;
    case 'Bookmarks::ReleaseProgress': {
      const releaseId = panel.release ? panel.release.get('id') : 'empty';
      return `/releases/${releaseId}/progress`;
    }
    case 'Bookmarks::DependencyReport':
      return `/bookmarks/dependency_reports/${panel.bookmarkId}`;
    case 'Bookmarks::PortfolioRoadmap':
      return `/bookmarks/portfolio_roadmaps/${panel.bookmarkId}`;
    case 'Bookmarks::CalendarReport':
      return `/bookmarks/calendar_reports/${panel.bookmarkId}`;
    case 'Bookmarks::FeatureBoard':
      return `/bookmarks/feature_boards/${panel.bookmarkId}`;
    case 'Bookmarks::InitiativeWorkflow':
      return `/bookmarks/initiative_workflows/${panel.bookmarkId}`;
    case 'Bookmarks::NowNextLaterRoadmap':
      return `/bookmarks/now_next_later_roadmaps/${panel.bookmarkId}`;
    case 'Bookmarks::IterationBurndown':
      return `/bookmarks/iteration_burndowns/${panel.bookmarkId}`;
    case 'Bookmarks::FeaturePriorityList':
      return `/bookmarks/feature_priority_lists/${panel.bookmarkId}`;
    case 'Bookmarks::EpicPriorityList':
      return `/bookmarks/epic_priority_lists/${panel.bookmarkId}`;
    case 'Bookmarks::InitiativePriorityList':
      return `/bookmarks/initiative_priority_lists/${panel.bookmarkId}`;
    case 'Bookmarks::IdeaPriorityList':
      return `/bookmarks/idea_priority_lists/${panel.bookmarkId}`;
    case 'Bookmarks::VelocityChart':
      return `/bookmarks/velocity_charts/${panel.bookmarkId}`;
    case 'Bookmarks::CumulativeFlowDiagram':
      return `/bookmarks/cumulative_flow_diagrams/${panel.bookmarkId}`;
    case 'Bookmarks::CycleTimeChart':
      return `/bookmarks/cycle_time_charts/${panel.bookmarkId}`;
    case 'Bookmarks::IdeaActivityPanel':
      return `/bookmarks/idea_activity_panels/${panel.bookmarkId}`;
  }
}

export function getPanelTitleContent(panel, updatePanel) {
  if (!panel) {
    return '';
  }
  switch (panel.type) {
    case 'SectionHeaderPanel': {
      const lineHeight = 32; // matches computed value of var(--default-line-height) from typography.less
      const additionalSpace = ROW_HEIGHT + PANEL_GAP;
      const maxLines = Math.floor(
        (lineHeight + (parseInt(panel.height, 10) - 1) * additionalSpace) /
          lineHeight
      );
      return (
        <Text
          style={{ WebkitLineClamp: maxLines }}
          class={classnames(
            'SectionHeaderInput',
            'react-in-place',
            'react-in-place__text',
            'react-in-place--inline',
            'react-in-place--no-empty-style'
          )}
          value={panel.name}
          nil='Enter section header'
          onChange={newName => {
            updatePanel(panel.id, panel.set('name', newName));
          }}
        />
      );
    }
    case 'RichTextPanel': {
      return null;
    }
    default: {
      return panel.name || '\u00a0';
    }
  }
}

export function supportsResizableContent(panel) {
  return [
    'Bookmarks::CustomPivot::Pivot',
    'Bookmarks::CustomPivotPivot',
    'Bookmarks::CustomPivot::List',
    'Bookmarks::CustomPivotList',
    'Bookmarks::FeatureGrid',
    'Bookmarks::IdeaGrid',
  ].includes(panel.type);
}

export function getPanelContent(panel, preview, width, height, padding) {
  let panelContent: any = '';
  switch (panel.type) {
    case 'Bookmarks::CustomPivot::Pivot':
    case 'Bookmarks::CustomPivotPivot':
      panelContent = (
        <Pivot panel={panel} preview={preview} fullScreen={false} />
      );
      break;
    case 'Bookmarks::CustomPivot::List':
    case 'Bookmarks::CustomPivotList':
    case 'Bookmarks::FeatureGrid':
    case 'Bookmarks::IdeaGrid':
      panelContent = <List panel={panel} preview={preview} padding={padding} />;
      break;
    case 'Bookmarks::IdeaStatusChart':
      panelContent = (
        <GenericBookmarkContent
          panel={panel}
          preview={preview}
          ariaLabel={`${terminology('Idea')} Status Chart`}
        />
      );
      break;
    case 'Bookmarks::IdeaPortalsWatchers':
      panelContent = (
        <GenericBookmarkContent
          panel={panel}
          preview={preview}
          ariaLabel={`${terminology('Ideas')} Portals & Watchers`}
          height='100%'
        />
      );
      break;
    case 'Bookmarks::IdeaActivityPanel':
      panelContent = (
        <GenericBookmarkContent
          panel={panel}
          preview={preview}
          ariaLabel={`${terminology('Ideas')} Activity`}
          height='100%'
        />
      );
      break;
    case 'Bookmarks::IdeaTopContributors':
      panelContent = (
        <GenericBookmarkContent
          panel={panel}
          preview={preview}
          ariaLabel={`${terminology('Ideas')} top contributors`}
          height='100%'
        />
      );
      break;
    case 'Bookmarks::CustomPivot::NivoChart':
      panelContent = (
        <NivoChart
          panel={panel}
          preview={preview}
          width={width}
          height={height}
        />
      );
      break;
    case 'Bookmarks::CustomPivot::Chart':
    case 'Bookmarks::CustomPivotChart':
      panelContent = (
        <GoogleChart
          fullScreen={false}
          panel={panel}
          preview={preview}
          width={width}
          height={height}
          padding={padding}
        />
      );
      break;
    case 'Bookmarks::CustomPivot::Timeline':
    case 'Bookmarks::CustomPivotTimeline':
      panelContent = <Timeline panel={panel} preview={preview} />;
      break;
    case 'Bookmarks::GanttRoadmap':
    case 'Bookmarks::EpicGanttRoadmap':
    case 'Bookmarks::EpicByReleaseGanttRoadmap':
    case 'Bookmarks::InitiativeGanttRoadmap':
      panelContent = <Gantt panel={panel} preview={preview} />;
      break;
    case 'Bookmarks::ReleaseProgress':
      panelContent = (
        <Progress
          // @ts-expect-error
          panel={panel}
          preview={preview}
          padding={padding}
          width={width}
          height={height}
        />
      );
      break;
    case 'ExtensionPanel':
      panelContent = <ExtensionPanel panel={panel} />;
      break;
    case 'SectionHeaderPanel':
      panelContent = null;
      break;
    case 'RichTextPanel':
      panelContent = <RichTextPanel panel={panel} />;
      break;
    case 'Bookmarks::ProjectTimeline':
      panelContent = <ProjectTimeline panel={panel} preview={preview} />;
      break;
    case 'Bookmarks::EpicTimeline':
      panelContent = <ProjectTimeline panel={panel} preview={preview} />;
      break;
    case 'Bookmarks::Roadmap':
      panelContent = <Roadmap panel={panel} preview={preview} />;
      break;
    case 'Bookmarks::DependencyReport':
      panelContent = (
        <GenericBookmarkContent
          panel={panel}
          preview={preview}
          ariaLabel='DependencyReport'
        />
      );
      break;
    case 'Bookmarks::PortfolioRoadmap':
      panelContent = (
        <GenericBookmarkContent
          panel={panel}
          preview={preview}
          ariaLabel='Portfolio Roadmap'
        />
      );
      break;
    case 'Bookmarks::CalendarReport':
      panelContent = (
        <GenericBookmarkContent
          panel={panel}
          preview={preview}
          ariaLabel='Calendar Report'
        />
      );
      break;
    case 'Bookmarks::FeatureBoard':
      panelContent = (
        <GenericBookmarkContent
          panel={panel}
          preview={preview}
          ariaLabel='Feature Board'
        />
      );
      break;
    case 'Bookmarks::InitiativeWorkflow':
      panelContent = (
        <GenericBookmarkContent
          panel={panel}
          preview={preview}
          ariaLabel='InitiativeWorkflow'
        />
      );
      break;
    case 'Bookmarks::NowNextLaterRoadmap':
      panelContent = (
        // @ts-expect-error
        <NowNextLater panel={panel} preview={preview} padding={padding} />
      );
      break;
    case 'Bookmarks::IterationBurndown':
      panelContent = (
        <DevelopChart
          panel={panel}
          preview={preview}
          ariaLabel={`${terminology('Iteration')} Burndown`}
        />
      );
      break;
    case 'Bookmarks::FeaturePriorityList':
    case 'Bookmarks::EpicPriorityList':
    case 'Bookmarks::InitiativePriorityList':
    case 'Bookmarks::IdeaPriorityList':
      panelContent = (
        // @ts-expect-error
        <PriorityList panel={panel} preview={preview} padding={padding} />
      );
      break;
    case 'Bookmarks::VelocityChart':
      panelContent = (
        <DevelopChart
          panel={panel}
          preview={preview}
          ariaLabel='Velocity Chart'
        />
      );
      break;
    case 'Bookmarks::CumulativeFlowDiagram':
      panelContent = (
        <DevelopChart
          panel={panel}
          preview={preview}
          ariaLabel='Cumulative flow diagram'
        />
      );
      break;
    case 'Bookmarks::CycleTimeChart':
      panelContent = (
        <DevelopChart
          panel={panel}
          preview={preview}
          ariaLabel='Cycle time chart'
        />
      );
      break;
    default:
      panelContent = <aha-empty-state>View not found</aha-empty-state>;
      break;
  }

  return panelContent;
}

export function openReport(panel, bookmarkId?) {
  let url = bookmarkURL(panel);

  // Special handling for IdeaActivityPanel - open the currently selected tab's report
  if (panel.type === 'Bookmarks::IdeaActivityPanel') {
    const selectedTabUrl = getSelectedTabBookmarkUrl(panel);
    if (selectedTabUrl) {
      url = selectedTabUrl;
    }
  }

  const form = document.createElement('form');
  form.setAttribute('id', 'dashboard-panel-dummy-form');
  form.setAttribute('target', '_blank');
  form.setAttribute('method', 'POST');
  if (url) {
    form.setAttribute('action', url);
  }

  const dashboardPanelField = document.createElement('input');
  dashboardPanelField.setAttribute('type', 'hidden');
  dashboardPanelField.setAttribute('name', 'dashboard_panel');
  dashboardPanelField.setAttribute('value', 'true');
  form.appendChild(dashboardPanelField);

  const csrfField = document.createElement('input');
  csrfField.setAttribute('type', 'hidden');
  csrfField.setAttribute('name', 'authenticity_token');
  csrfField.setAttribute('value', window.csrfToken());
  form.appendChild(csrfField);

  if (bookmarkId) {
    const bookmarkIdField = document.createElement('input');
    bookmarkIdField.setAttribute('type', 'hidden');
    bookmarkIdField.setAttribute('name', 'dashboard_id');
    bookmarkIdField.setAttribute('value', bookmarkId);
    form.appendChild(bookmarkIdField);
  }

  document.body.appendChild(form);
  form.submit();
  form.remove();
}

function getSelectedTabBookmarkUrl(panel) {
  try {
    const panelElement = document.getElementById(`Dashboard-Panel-${panel.id}`);
    if (!panelElement) {
      return null;
    }

    const selectedTab = panelElement.querySelector(
      ':scope aha-ez-tab[aria-selected="true"]'
    );
    if (!selectedTab) {
      return null;
    }

    const bookmarkUrl = selectedTab.getAttribute('data-bookmark-url');
    return bookmarkUrl;
  } catch (error) {
    console.warn('Failed to get selected tab bookmark URL:', error);
    return null;
  }
}

export function removeFalseOptions(filter) {
  filter.forEach((v, k) => {
    if (v === 'false') {
      filter = filter.delete(k);
    }
  });

  return filter;
}

export function RowCount(panels, { includePadding = false } = {}) {
  const row = 1;
  const maxRow = panels
    .toList()
    .map(panel => parseInt(panel.row, 10) + parseInt(panel.height, 10))
    .max();

  // Add 4 rows to the bottom so the grid can be expanded.
  return (maxRow || row) + (includePadding ? 4 : 0);
}

export function reportTypeToIconClass(reportType) {
  switch (reportType) {
    case 'Bookmarks::CustomPivotTimeline':
    case 'Bookmarks::CustomPivot::Timeline':
    case 'Bookmarks::ProjectTimeline':
    case 'Bookmarks::EpicTimeline':
    case 'Bookmarks::Roadmap':
      return 'aha-icon aha-icon-roadmap';
    case 'Bookmarks::CustomPivotList':
    case 'Bookmarks::CustomPivot::List':
    case 'Bookmarks::FeatureGrid':
    case 'Bookmarks::IdeaGrid':
      return 'fa-regular fa-rectangle-list';
    case 'Bookmarks::CustomPivotPivot':
    case 'Bookmarks::CustomPivot::Pivot':
      return 'aha-icon aha-icon-pivot';
    case 'Bookmarks::CustomPivotChart':
    case 'Bookmarks::CustomPivot::Chart':
    case 'Bookmarks::CustomPivot::NivoChart':
      return 'fa-regular fa-chart-column';
    case 'Bookmarks::GanttRoadmap':
    case 'Bookmarks::EpicGanttRoadmap':
    case 'Bookmarks::EpicByReleaseGanttRoadmap':
    case 'Bookmarks::InitiativeGanttRoadmap':
      return 'fa-regular fa-chart-gantt';
    case 'Bookmarks::DependencyReport':
    case 'Bookmarks::PortfolioRoadmap':
      return 'fa-regular fa-chart-bar';
    case 'Bookmarks::CalendarReport':
      return 'fa-regular fa-calendar';
    case 'Bookmarks::FeatureBoard':
      return 'aha-icon aha-icon-workflow';
    case 'Bookmarks::InitiativeWorkflow':
      return 'aha-icon aha-icon-workflow';
    case 'Bookmarks::NowNextLaterRoadmap':
      return 'aha-icon aha-icon-workflow';
    case 'Bookmarks::IterationBurndown':
      return 'fa-regular fa-chart-line-down';
    case 'Bookmarks::VelocityChart':
      return 'fa-regular fa-chart-column';
    case 'Bookmarks::CumulativeFlowDiagram':
      return 'fa-regular fa-chart-line';
    case 'Bookmarks::CycleTimeChart':
      return 'fa-regular fa-chart-scatter';
    default:
      return 'fa-regular fa-rectangle-list';
  }
}

export function reportTypeToRecordType(reportType, context) {
  switch (reportType) {
    case 'roadmap':
      return 'Bookmarks::CustomPivotTimeline';
    case 'list':
      if (context === CONTEXT_DEFAULT_VIEW_SETTINGS) {
        return 'Bookmarks::CustomPivotList';
      } else {
        return 'Bookmarks::CustomPivotList,Bookmarks::FeatureGrid,Bookmarks::IdeaGrid';
      }
    case 'pivot':
      return 'Bookmarks::CustomPivotPivot';
    case 'chart':
      if (context === CONTEXT_IDEA_PORTAL_SECTION) {
        return 'Bookmarks::CustomPivotChart,Bookmarks::IdeaPriorityChart';
      } else {
        return 'Bookmarks::CustomPivotChart';
      }
    case 'features_roadmap':
      return 'Bookmarks::ProjectTimeline';
    case 'epics_roadmap':
      return 'Bookmarks::EpicTimeline';
    case 'starter_roadmap':
      return 'Bookmarks::Roadmap';
    case 'portfolio_roadmap':
      return 'Bookmarks::PortfolioRoadmap';
    case 'gantt':
      if (context === CONTEXT_IDEA_PORTAL_SECTION) {
        return 'Bookmarks::GanttRoadmap,Bookmarks::EpicGanttRoadmap';
      } else {
        return 'Bookmarks::GanttRoadmap';
      }
    case 'epic_gantt':
      return 'Bookmarks::EpicGanttRoadmap';
    case 'epic_by_release_gantt':
      return 'Bookmarks::EpicByReleaseGanttRoadmap';
    case 'initiative_gantt':
      return 'Bookmarks::InitiativeGanttRoadmap';
    case 'now_next_later_roadmap':
      return 'Bookmarks::NowNextLaterRoadmap';
    case 'feature_priority_list':
      return 'Bookmarks::FeaturePriorityList';
    case 'epic_priority_list':
      return 'Bookmarks::EpicPriorityList';
    case 'initiative_priority_list':
      return 'Bookmarks::InitiativePriorityList';
    case 'idea_priority_list':
      return 'Bookmarks::IdeaPriorityList';
    case 'release_progress':
      return 'Bookmarks::ReleaseProgress';
    case 'calendar':
      return 'Bookmarks::CalendarReport';
    case 'capacity_report':
      return 'Bookmarks::CapacityReport';
    case 'dependency_report':
      return 'Bookmarks::DependencyReport';
    case 'hierarchy_report':
      return 'Bookmarks::StrategyTable';
    case 'diagram_report':
      return 'Bookmarks::StrategyTree';
    case 'feature_board':
      return 'Bookmarks::FeatureBoard';
    case 'initiative_workflow':
      return 'Bookmarks::InitiativeWorkflow';
    case 'idea_grid':
      return 'Bookmarks::IdeaGrid';
    case 'opportunity_report':
      return 'Bookmarks::OpportunityReport';
    case 'feature_grid':
      return 'Bookmarks::FeatureGrid';
    case 'dashboard':
      return 'dashboards';
    case 'iteration_burndown':
      return 'Bookmarks::IterationBurndown';
    case 'velocity_chart':
      return 'Bookmarks::VelocityChart';
    case 'cumulative_flow_diagram':
      return 'Bookmarks::CumulativeFlowDiagram';
    case 'cycle_time_chart':
      return 'Bookmarks::CycleTimeChart';
    default:
      if (context === CONTEXT_IDEA_PORTAL_SECTION) {
        return 'Bookmarks::CustomPivotPivot,Bookmarks::CustomPivotChart,Bookmarks::CustomPivotList,Bookmarks::CustomPivotTimeline,Bookmarks::FeatureGrid,Bookmarks::IdeaGrid,Bookmarks::GanttRoadmap,Bookmarks::EpicGanttRoadmap,Bookmarks::InitiativeGanttRoadmap,Bookmarks::Roadmap,Bookmarks::ProjectTimeline,Bookmarks::EpicTimeline,Bookmarks::CalendarReport,Bookmarks::IdeaPriorityChart,Bookmarks::CapacityReport,Bookmarks::DependencyReport,Bookmarks::StrategyTree,Bookmarks::StrategyTable,Bookmarks::PortfolioRoadmap,Bookmarks::FeatureBoard,Bookmarks::NowNextLaterRoadmap,Bookmarks::OpportunityReport,Bookmarks::InitiativeWorkflow';
      } else {
        const presetGroupNames = [
          'all',
          'recents',
          'favorites',
          'created_by_me',
        ];
        if (
          window.railsEnv === 'development' &&
          !presetGroupNames.includes(reportType)
        ) {
          console.warn(
            'reportTypeToRecordType: Unknown report type',
            reportType
          );
        }
        return 'Bookmarks::CustomPivotPivot,Bookmarks::CustomPivotChart,Bookmarks::CustomPivotList,Bookmarks::CustomPivotTimeline,Bookmarks::FeatureGrid,Bookmarks::IdeaGrid,Bookmarks::GanttRoadmap,Bookmarks::EpicGanttRoadmap,Bookmarks::InitiativeGanttRoadmap,Bookmarks::ProjectTimeline,Bookmarks::EpicTimeline,Bookmarks::Roadmap,Bookmarks::DependencyReport,Bookmarks::PortfolioRoadmap,Bookmarks::CalendarReport,Bookmarks::InitiativeWorkflow,Bookmarks::FeatureBoard,Bookmarks::IterationBurndown,Bookmarks::VelocityChart,Bookmarks::CumulativeFlowDiagram,Bookmarks::CycleTimeChart';
      }
  }
}

// TODO: Use terminology
export function reportTypeToSearchPlaceholder(reportType) {
  switch (reportType) {
    case 'all':
      return '';
    case 'recents':
    case 'favorites':
      return reportType;
    case 'list':
    case 'roadmap':
    case 'pivot':
    case 'chart':
      return reportType + 's';
    case 'gantt':
      return 'Releases, phases, and features Gantts';
    case 'epic_gantt':
      return 'Releases, epics, and features Gantt charts';
    case 'epic_by_release_gantt':
      return 'Releases, epics, and features Gantts';
    case 'initiative_gantt':
      return 'strategic roadmaps';
    case 'release_progress':
      return 'Progress chart';
    case 'features_roadmap':
      return 'Feature roadmaps';
    case 'epics_roadmap':
      return 'Epic roadmaps';
    case 'starter_roadmap':
      return 'Starter roadmaps';
    case 'portfolio_roadmap':
      return 'Portfolio roadmaps';
    case 'capacity_report':
      return 'Capacity reports';
    case 'dependency_report':
      return 'Dependency reports';
    case 'hierarchy_report':
      return 'Hierarchy';
    case 'diagram_report':
      return 'Diagram';
    case 'feature_priority_list':
      return 'Feature priority lists';
    case 'idea_priority_list':
      return 'Idea priority lists';
    case 'now_next_later_roadmap':
      return 'Next, Next, Later roadmap';
    case 'opportunity_report':
      return 'Salesforce opportunity reports';
    case 'iteration_burndown':
      return `${terminology('Iteration')} burndown`;
    case 'velocity_chart':
      return 'Velocity chart';
    case 'cumulative_flow_diagram':
      return 'Cumulative flow diagram';
    case 'cycle_time_chart':
      return 'Cycle & lead time chart';
    default:
      return reportType.replace(/_/g, ' ');
  }
}

export function recordTypeToMetaInfo(recordType) {
  switch (recordType) {
    case 'Bookmarks::CustomPivotTimeline':
    case 'Bookmarks::CustomPivot::Timeline':
      return {
        type: 'Roadmap',
        image: require('images/report_wizard/custom-selected.svg'),
        alt: 'Roadmap image',
      };
    case 'Bookmarks::CustomPivotList':
    case 'Bookmarks::CustomPivot::List':
    case 'Bookmarks::FeatureGrid':
    case 'Bookmarks::IdeaGrid':
      return {
        type: 'List',
        image: require('images/report_wizard/list-selected.svg'),
        alt: 'List image',
      };
    case 'Bookmarks::CustomPivotPivot':
    case 'Bookmarks::CustomPivot::Pivot':
      return {
        type: 'Pivot',
        image: require('images/report_wizard/pivot-selected.svg'),
        alt: 'Pivot image',
      };
    case 'Bookmarks::CustomPivotChart':
    case 'Bookmarks::CustomPivot::Chart':
    case 'Bookmarks::CustomPivot::NivoChart':
      return {
        type: 'Chart',
        image: require('images/report_wizard/chart-selected.svg'),
        alt: 'Chart image',
      };
    case 'Bookmarks::GanttRoadmap':
      return {
        type: 'Gantt',
        image: require('images/report_wizard/gantt-selected.svg'),
        alt: 'Gantt',
      };
    case 'Bookmarks::EpicGanttRoadmap':
      return {
        type: `${terminology('Epic')} Gantt`,
        image: require('images/report_wizard/gantt-selected.svg'),
        alt: 'Epic Gantt',
      };
    case 'Bookmarks::EpicByReleaseGanttRoadmap':
      return {
        type: `${terminology('Releases')}, ${terminology(
          'epics'
        )} and ${terminology('features')} Gantt`,
        image: require('images/report_wizard/gantt-selected.svg'),
        alt: `${terminology('Releases')}, ${terminology(
          'epics'
        )} and ${terminology('features')} Gantt`,
      };
    case 'Bookmarks::InitiativeGanttRoadmap':
      return {
        type: 'Strategic Roadmap',
        image: require('images/report_wizard/gantt-selected.svg'),
        alt: 'Strategic Roadmap',
      };
    case 'Bookmarks::Release Progress':
      return {
        type: `${terminology('Release')} Progress`,
        image: require('images/report_wizard/progress-selected.svg'),
        alt: `${terminology('Release')} Progress`,
      };
    case 'Bookmarks::ProjectTimeline':
      return {
        type: `${terminology('Features')} roadmap`,
        image: require('images/report_wizard/features-selected.svg'),
        alt: `${terminology('Features')} roadmap`,
      };
    case 'Bookmarks::EpicTimeline':
      return {
        type: `${terminology('Epics')} roadmap`,
        image: require('images/report_wizard/features-selected.svg'),
        alt: `${terminology('Epics')} roadmap`,
      };
    case 'Bookmarks::Roadmap':
      return {
        type: 'Starter roadmap',
        image: require('images/report_wizard/starter-selected.svg'),
        alt: 'Starter roadmap',
      };
    case 'Bookmarks::DependencyReport':
      return {
        type: 'Dependency Report',
        image: require('images/report_wizard/dependency-selected.svg'),
        alt: 'Dependency Report',
      };
    case 'Bookmarks::PortfolioRoadmap':
      return {
        type: 'Portfolio Roadmap',
        image: require('images/report_wizard/portfolio-selected.svg'),
        alt: 'Portfolio Roadmap',
      };
    case 'Bookmarks::CalendarReport':
      return {
        type: 'Calendar Report',
        image: require('images/report_wizard/calendar-selected.svg'),
        alt: 'Calendar Report',
      };
    case 'Bookmarks::FeatureBoard':
      return {
        type: `${terminology('Features')} Workflow`,
        image: require('images/report_wizard/workflow-selected.svg'),
        alt: `${terminology('Features')} Workflow`,
      };
    case 'Bookmarks::InitiativeWorkflow':
      return {
        type: `${terminology('Initiatives')} Workflow`,
        image: require('images/report_wizard/workflow-selected.svg'),
        alt: `${terminology('Initiatives')} Workflow`,
      };
    case 'Bookmarks::NowNextLaterRoadmap':
      return {
        type: `Now, Next, Later Roadmap`,
        image: require('images/report_wizard/now-next-later-selected.svg'),
        alt: `Now, Next, Later Roadmap`,
      };
    case 'Bookmarks::OpportunityReport':
      return {
        type: 'Salesforce opportunity report',
        image: require('images/report_wizard/opportunity-report-selected.svg'),
        alt: 'Salesforce opportunity report',
      };
    case 'Bookmarks::IterationBurndown':
      return {
        type: `${terminology('Iteration')} Burndown`,
        image: require('images/report_wizard/burndown-selected.svg'),
        alt: `${terminology('Iteration')} Burndown`,
      };
    case 'Bookmarks::VelocityChart':
      return {
        type: 'Velocity Chart',
        image: require('images/report_wizard/velocity-selected.svg'),
        alt: 'Velocity Chart',
      };
    case 'Bookmarks::CumulativeFlowDiagram':
      return {
        type: 'Cumulative Flow Diagram',
        image: require('images/report_wizard/cumulative-flow-selected.svg'),
        alt: 'Cumulative Flow Diagram',
      };
    case 'Bookmarks::CycleTimeChart':
      return {
        type: 'Cycle & Lead Time Chart',
        image: require('images/report_wizard/cycle-lead-time-selected.svg'),
        alt: 'Cycle & Lead Time Chart',
      };
    default:
      return {
        type: 'Report',
        image: require('images/report_wizard/list-selected.svg'),
        alt: 'Report',
      };
  }
}

export function analyticsTrackEvent(eventName, params = {}) {
  window.AhaAnalytics?.track('Feature-6820408660341948373', eventName, params);
}

const withAdditionalReports = (arr, context) => {
  const additionalReports = [
    'features_roadmap',
    'epics_roadmap',
    'starter_roadmap',
    'dependency_report',
    'portfolio_roadmap',
    'calendar',
    'feature_board',
    'initiative_workflow',
  ];

  const developReports = [
    'iteration_burndown',
    'velocity_chart',
    'cumulative_flow_diagram',
    'cycle_time_chart',
  ];
  const ideasOnlyReports = ['chart', 'list', 'pivot', 'idea_priority_list'];

  let arrWithAdditionalReports = arr;
  if (context !== DASHBOARD_PANEL_CONTEXT_DASHBOARD) {
    arrWithAdditionalReports = arr.filter(
      ({ value }) => !additionalReports.includes(value)
    );
  }

  if (!window.currentAccount?.teamworkOrDevelopFlavor) {
    arrWithAdditionalReports = arrWithAdditionalReports.filter(
      ({ value }) => !developReports.includes(value)
    );
  }

  if (window.currentAccount?.onlyIdeasFlavor) {
    arrWithAdditionalReports = arrWithAdditionalReports.filter(({ value }) =>
      ideasOnlyReports.includes(value)
    );
  }

  if (!window.featureFlags?.ai_1919_ideas_overview_dashboard) {
    arrWithAdditionalReports = arrWithAdditionalReports.filter(
      ({ value }) => value !== 'ideas_overview'
    );
  }

  return arrWithAdditionalReports;
};

export function sectionedListValuesForFilterableTypes(context) {
  const allReports = withAdditionalReports(
    [
      {
        text: 'Chart',
        value: 'chart',
      },
      {
        text: 'List',
        value: 'list',
      },
      {
        text: 'Pivot',
        value: 'pivot',
      },
      {
        text: `${terminology('Features')} roadmap`,
        value: 'features_roadmap',
      },
      {
        text: `${terminology('Epics')} roadmap`,
        value: 'epics_roadmap',
      },
      {
        text: 'Starter roadmap',
        value: 'starter_roadmap',
      },
      {
        text: 'Now, Next, Later roadmap',
        value: 'now_next_later_roadmap',
      },
      {
        text: `${terminology('Feature')} priority list`,
        value: 'feature_priority_list',
      },
      {
        text: `${terminology('Epic')} priority list`,
        value: 'epic_priority_list',
      },
      {
        text: `${terminology('Initiative')} priority list`,
        value: 'initiative_priority_list',
      },
      {
        text: `${terminology('Idea')} priority list`,
        value: 'idea_priority_list',
      },
      {
        text: `${terminology('Ideas')} overview`,
        value: 'ideas_overview',
      },
      {
        text: 'Custom roadmap',
        value: 'roadmap',
      },
      {
        text: 'Strategic roadmap',
        value: 'initiative_gantt',
      },
      {
        text: 'Gantt',
        value: 'gantt',
      },
      {
        text: `${terminology('Epic')} Gantt`,
        value: 'epic_gantt',
      },
      {
        text: `${terminology('Releases')}, ${terminology(
          'epics'
        )} and ${terminology('features')} Gantt`,
        value: 'epic_by_release_gantt',
      },
      {
        text: 'Dependency report',
        value: 'dependency_report',
      },
      {
        text: 'Portfolio roadmap',
        value: 'portfolio_roadmap',
      },
      {
        text: 'Calendar report',
        value: 'calendar',
      },
      {
        text: `${terminology('Features')} workflow`,
        value: 'feature_board',
      },
      {
        text: `${terminology('Initiatives')} workflow`,
        value: 'initiative_workflow',
      },
      {
        text: `${terminology('Iteration')} burndown`,
        value: 'iteration_burndown',
      },
      {
        text: 'Velocity chart',
        value: 'velocity_chart',
      },
      {
        text: 'Cumulative flow diagram',
        value: 'cumulative_flow_diagram',
      },
      {
        text: 'Cycle & lead time chart',
        value: 'cycle_time_chart',
      },
    ],
    context
  );

  // Restrict available reports to those supported by the whiteboard
  if (context === DASHBOARD_PANEL_CONTEXT_WHITEBOARD) {
    const availableInWhiteboard = [
      'list',
      'pivot',
      'chart',
      'features_roadmap',
      'epics_roadmap',
      'feature_priority_list',
      'epic_priority_list',
      'initiative_priority_list',
      'idea_priority_list',
      'roadmap',
      'gantt',
      'epic_by_release_gantt',
      'epic_gantt',
      'initiative_gantt',
    ];
    return allReports.filter(({ value }) => {
      return availableInWhiteboard.includes(value);
    });
  }
  return allReports;
}

export const IMAGES_BY_REPORT_TYPE = {
  existing: {
    image: require('images/report_wizard/existing-view.svg'),
    selectedImage: require('images/report_wizard/existing-view-selected.svg'),
  },
  section_header: {
    image: require('images/report_wizard/section-header.png'),
    selectedImage: require('images/report_wizard/section-header-selected.png'),
  },
  chart: {
    image: require('images/report_wizard/chart.svg'),
    selectedImage: require('images/report_wizard/chart-selected.svg'),
  },
  list: {
    image: require('images/report_wizard/list.svg'),
    selectedImage: require('images/report_wizard/list-selected.svg'),
  },
  pivot: {
    image: require('images/report_wizard/pivot.svg'),
    selectedImage: require('images/report_wizard/pivot-selected.svg'),
  },
  roadmap: {
    image: require('images/report_wizard/roadmap.svg'),
    selectedImage: require('images/report_wizard/roadmap-selected.svg'),
  },
  features_roadmap: {
    image: require('images/report_wizard/features.svg'),
    selectedImage: require('images/report_wizard/features-selected.svg'),
  },
  epics_roadmap: {
    image: require('images/report_wizard/features.svg'),
    selectedImage: require('images/report_wizard/features-selected.svg'),
  },
  starter_roadmap: {
    image: require('images/report_wizard/starter.svg'),
    selectedImage: require('images/report_wizard/starter-selected.svg'),
  },
  gantt: {
    image: require('images/report_wizard/gantt.svg'),
    selectedImage: require('images/report_wizard/gantt-selected.svg'),
  },
  epic_gantt: {
    image: require('images/report_wizard/gantt.svg'),
    selectedImage: require('images/report_wizard/gantt-selected.svg'),
  },
  epic_by_release_gantt: {
    image: require('images/report_wizard/gantt.svg'),
    selectedImage: require('images/report_wizard/gantt-selected.svg'),
  },
  initiative_gantt: {
    image: require('images/report_wizard/gantt.svg'),
    selectedImage: require('images/report_wizard/gantt-selected.svg'),
  },
  release_progress: {
    image: require('images/report_wizard/progress.svg'),
    selectedImage: require('images/report_wizard/progress-selected.svg'),
  },
  extension_panel: {
    image: require('images/report_wizard/gantt.svg'),
    selectedImage: require('images/report_wizard/gantt-selected.svg'),
  },
  dependency_report: {
    image: require('images/report_wizard/dependency.svg'),
    selectedImage: require('images/report_wizard/dependency-selected.svg'),
  },
  portfolio_roadmap: {
    image: require('images/report_wizard/portfolio.svg'),
    selectedImage: require('images/report_wizard/portfolio-selected.svg'),
  },
  calendar: {
    image: require('images/report_wizard/calendar.svg'),
    selectedImage: require('images/report_wizard/calendar-selected.svg'),
  },
  feature_board: {
    image: require('images/report_wizard/workflow.svg'),
    selectedImage: require('images/report_wizard/workflow-selected.svg'),
  },
  initiative_workflow: {
    image: require('images/report_wizard/workflow.svg'),
    selectedImage: require('images/report_wizard/workflow-selected.svg'),
  },
  ideas_overview: {
    image: require('images/report_wizard/chart.svg'),
    selectedImage: require('images/report_wizard/chart-selected.svg'),
  },
  now_next_later_roadmap: {
    image: require('images/report_wizard/now-next-later.svg'),
    selectedImage: require('images/report_wizard/now-next-later-selected.svg'),
  },
  iteration_burndown: {
    image: require('images/report_wizard/burndown.svg'),
    selectedImage: require('images/report_wizard/burndown-selected.svg'),
  },
  feature_priority_list: {
    image: require('images/report_wizard/list.svg'),
    selectedImage: require('images/report_wizard/list-selected.svg'),
  },
  epic_priority_list: {
    image: require('images/report_wizard/list.svg'),
    selectedImage: require('images/report_wizard/list-selected.svg'),
  },
  initiative_priority_list: {
    image: require('images/report_wizard/list.svg'),
    selectedImage: require('images/report_wizard/list-selected.svg'),
  },
  idea_priority_list: {
    image: require('images/report_wizard/list.svg'),
    selectedImage: require('images/report_wizard/list-selected.svg'),
  },
};

// Views for the new panel modal
export const VIEW_PANEL_LIBRARY = 'panelLibrary';
export const VIEW_EXISTING_REPORTS = 'existingReports';
export const VIEW_EXTENSION_PANELS = 'extensionPanels';

export function showLegendOption(panelType) {
  return [
    'Bookmarks::CustomPivot::Pivot',
    'Bookmarks::CustomPivotPivot',
    'Bookmarks::CustomPivot::Timeline',
    'Bookmarks::CustomPivotTimeline',
    'Bookmarks::CustomPivot::Chart',
    'Bookmarks::CustomPivot::NivoChart',
    'Bookmarks::CustomPivotChart',
  ].includes(panelType);
}

// When you add a new type and you want 'NEW' icons, add the type here.
export function showNewOption(exampleType) {
  return ['ideas_overview'].includes(exampleType);
}

export function filterableTypesForContext(context) {
  if (context === CONTEXT_IDEA_PORTAL_SECTION) {
    return []; // https://big.aha.io/develop/features/AI-1581
  } else if (context === CONTEXT_DEFAULT_VIEW_SETTINGS) {
    return [];
  } else {
    return sectionedListValuesForFilterableTypes(context);
  }
}

export function contextToName(context, plural = false, capitalize = false) {
  let name =
    context === DASHBOARD_PANEL_CONTEXT_NOTE ||
    context === DASHBOARD_PANEL_CONTEXT_WHITEBOARD ||
    context === CONTEXT_IDEA_PORTAL_SECTION
      ? 'view'
      : 'panel';
  if (capitalize) name = name.replace(/^\w/, c => c.toUpperCase());

  return plural ? `${name}s` : name;
}

export function clampPanel({ row, column, width, height, rowCount }) {
  const clampedRow = clamp(row, 1, rowCount);
  const clampedColumn = clamp(column, 1, COLUMN_COUNT);

  return {
    row: clampedRow,
    column: clampedColumn,
    width: clamp(width, 1, COLUMN_COUNT - clampedColumn + 1),
    height: clamp(height, 1, rowCount - row + 1),
  };
}

export function panelUrlParams({
  preview,
  publishing,
  showLegend,
  bookmarkId,
  bookmarkStartDate,
  bookmarkEndDate,
}) {
  const urlParams = new URLSearchParams();
  const currentParams = new URLSearchParams(window.location.search);

  // To ensure dark mode is consistent, pass in the currentProjectId param
  if (window.currentProjectId) {
    urlParams.set('project_id', window.currentProjectId);
  }

  if (preview) {
    urlParams.set('preview', 'true');
  }

  if (publishing) {
    urlParams.set('publishing', 'true');
  }

  if (showLegend) {
    urlParams.set('show_legend', 'true');
  }

  if (bookmarkStartDate) {
    urlParams.set('bookmark_start_date', bookmarkStartDate);
  }

  if (bookmarkEndDate) {
    urlParams.set('bookmark_end_date', bookmarkEndDate);
  }

  const publishableId = currentParams.get('publishable_id');
  if (publishableId) {
    urlParams.set('publishable_id', publishableId);
  }

  const publishableType = currentParams.get('publishable_type');
  if (publishableType) {
    urlParams.set('publishable_type', publishableType);
  }

  if (bookmarkId) {
    urlParams.set('dashboard_id', bookmarkId);
  }
  return urlParams;
}

export function activateSectionHeaderEdit(panel) {
  const panelElement = $(`#Dashboard-Panel-${panel.id}`);
  const input = panelElement?.find('.SectionHeaderInput');
  if (input) {
    input.click();
    input.focus();
  }
}

export const analyticsType = (selectedReport, currentView) => {
  switch (currentView) {
    case VIEW_EXISTING_REPORTS:
      switch (selectedReport.record_type) {
        case 'Bookmarks::GanttRoadmap':
          return 'Releases gantt';
        case 'Bookmarks::EpicGanttRoadmap':
          return 'Epics gantt';
        case 'Bookmarks::EpicByReleaseGanttRoadmap':
          return 'Releases, epics, and features Gantt';
        case 'Bookmarks::CalendarReport':
          return 'Releases calendar';
        case 'Bookmarks::IdeaGrid':
          return 'Ideas list';
        case 'Bookmarks::IdeaPriorityChart':
          return 'Ideas chart';
        case 'Bookmarks::FeatureGrid':
          return 'Features list';
        case 'Bookmarks::FeatureBoard':
          return 'Features workflow';
        case 'Bookmarks::InitiativeWorkflow':
          return 'Initiative workflow';
        case 'Bookmarks::Roadmap':
          return 'Starter roadmap';
        case 'Bookmarks::PortfolioRoadmap':
          return 'Portfolio roadmap';
        case 'Bookmarks::InitiativeGanttRoadmap':
          return 'Strategic roadmap';
        case 'Bookmarks::ProjectTimeline':
          return 'Features roadmap';
        case 'Bookmarks::EpicTimeline':
          return 'Epics roadmap';
        case 'Bookmarks::CustomPivot':
          return 'Custom pivot';
        case 'Bookmarks::CustomPivotList':
          return 'List report';
        case 'Bookmarks::CustomPivotPivot':
          return 'Pivot report';
        case 'Bookmarks::CustomPivotChart':
          return 'Chart report';
        case 'Bookmarks::CustomPivotRoadmap':
          return 'Custom roadmap';
        case 'Bookmarks::CapacityReport':
          return 'Capacity report';
        case 'Bookmarks::DependencyReport':
          return 'Dependency report';
        case 'Bookmarks::StrategyTable':
          return 'Hierarchy report';
        case 'Bookmarks::StrategyTree':
          return 'Diagram report';
        case 'Bookmarks::NowNextLaterRoadmap':
          return 'Now, Next, Later roadmap';
        case 'Bookmarks::IterationBurndown':
          return 'Sprint burndown';
        case 'Bookmarks::FeaturePriorityList':
          return 'Feature priority list';
        case 'Bookmarks::EpicPriorityList':
          return 'Epic priority list';
        case 'Bookmarks::InitiativePriorityList':
          return 'Initiative priority list';
        case 'Bookmarks::IdeaPriorityList':
          return 'Idea priority list';
        case 'Bookmarks::VelocityChart':
          return 'Velocity chart';
        case 'Bookmarks::CumulativeFlowDiagram':
          return 'Cumulative flow diagram';
        case 'Bookmarks::CycleTimeChart':
          return 'Cycle & lead time chart';
        default:
          return 'Unknown Report';
      }
    case VIEW_EXTENSION_PANELS:
      return 'Extension view';
    default:
      switch (selectedReport.record_type) {
        case 'list_goal_status':
          return 'List report';
        case 'chart_features_by_status':
          return 'Chart report';
        case 'chart_recently_shipped_features':
          return 'Chart report';
        case 'pivot_trending_ideas':
          return 'Pivot Report';
        case 'initiative_gantt':
          return 'Strategic roadmap';
        case 'gantt':
          return 'Releases gantt';
      }
  }
};
